export default "/fonts/PublicSans-Medium.ttf?1c3ccd93d7d57ea4d2a9197aa5f20f13";